module.exports = __webpack_public_path__ + "static/media/Image05.bd43bddb.png";